// Temporary setup. Once API integrated will return correct data
const defaultState = {
  searchTerm: "",
};

const searchResults = (state = [], action) => {
  switch (action.type) {
    case "SET_SEARCH_RESULTS":
      return Object.assign({}, state, action.data);
  }

  return state;
};

export default searchResults;
